/**
 * Debug logging utility
 * Centralized logging functions for the application
 */

/**
 * Log debug information
 * @param {string} name - Log name/identifier
 * @param {Object} parameters - Additional parameters to log
 */
export function mjDebugLog(name, parameters = {}) {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[DEBUG] ${name}`, parameters);
  }
}

/**
 * Log error information
 * @param {string} name - Error name/identifier
 * @param {Object} parameters - Additional parameters to log
 */
export function mjDebugError(name, parameters = {}) {
  console.error(`[ERROR] ${name}`, parameters);
}

